<template>
  <div class="news-policy-modular">
    <div class="header-modular">
      <headerInfo ref="headerModular" :number="cartNum"></headerInfo>
    </div>
    <div class="header-menu-bar-modular">
      <div class="menu-bar">
        <div class="menu-bar-item">
          <span class="top-bar-title" @click="toPersonCenter()">{{
            currLanguage == 3 ? "Home" : pageTextArr[0]
          }}</span>
          <img
            class="top-bar-icon"
            src="../assets/productDetail/top-bar-icon.png"
            alt=""
          />
        </div>
        <div class="menu-bar-item">
          <span class="top-bar-title">{{ titleName }}</span>
        </div>
        <!-- <div class="menu-bar-item">
          <span class="top-bar-title">{{ itemName }}</span>
        </div> -->
      </div>
    </div>
    <div class="news-policy-content">
      <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">{{
          currLanguage == 3 ? "Home" : pageTextArr[0]
        }}</el-breadcrumb-item>
        <el-breadcrumb-item><a href="/"></a>{{ titleName }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ itemName }}</el-breadcrumb-item>
      </el-breadcrumb> -->
      <div v-html="detail" class="news-policy-detail"></div>
    </div>
  </div>
</template>

<script>
import headerInfo from "../components/public/headerInfo";

export default {
  components: {
    headerInfo,
  },
  name: "newsPolicy",
  data() {
    return {
      id: "",
      detail: "",
      titleName: "",
      itemName: "",
      currLanguage: localStorage.getItem("curLanguageType"),
      pageTextArr: ["首页"],
    };
  },
  watch: {
    // detail() {
    //   // console.log('watch',detail);
    //   // this.$parent.$parent.reload();
    // },
  },

  created() {
    // this.titleName = this.$route.query.titleName;
    // this.itemName = this.$route.query.itemName;
    this.id = this.$route.query.id;
    // this.detail = localStorage.getItem("detail");
    // this.$parent.$parent.reload();

    // console.log('this.detail',this.detail);
  },
  methods: {
    /**
     * 获取页面底部
     */
    getBottomDetail() {
      let that = this;
      this.$http.getBottomDetail(
        { id: that.id },
        (res) => {
          if (res.ret == 1) {
            that.detail = res.data.detail;
            if (
              that.detail &&
              this.currLanguage != 3 &&
              this.currLanguage != 1
            ) {
              that.translateApiData(that.detail, 1);
              that.translateApiData(res.data.name, 2);
            } else {
              if (this.currLanguage == 3) {
                that.detail = res.data.eng_detail;
                that.titleName = res.data.eng_name;
              } else {
                that.detail = res.data.detail;
                that.titleName = res.data.name;
              }
            }
          } else {
            // this.$message.error(res.msg);
          }
        },
        (res) => {
          // this.$message.error(res.msg);
        }
      );
      // }
    },
    /**
     * 处理APIde数据进行翻译
     * @param {*} data
     */
    translateApiData(data, type) {
      let that = this;
      let newTextArr = [];
      newTextArr.push(data);
      that.languageTranslateByArr(newTextArr, type);
    },

    /**
     * 语言翻译 - 数组
     * @param {*} arr
     */
    languageTranslateByArr(arr, type) {
      let that = this;
      this.translateByArr(
        arr,
        (res) => {
          // 翻译api类型
          that.processingResultsByArr(res.data, type);
        },
        (res) => {}
      );
    },
    /**
     * api 处理返回的翻译数据
     * @param {*} data
     */
    processingResultsByArr(data, type) {
      let that = this;
      if (type == 1) {
        data.forEach((v, i) => {
          that.detail = v.translation;
        });
      } else {
        data.forEach((v, i) => {
          that.titleName = v.translation;
        });
      }
    },

    translateByArr(arr, callback, errCallBack) {
      let that = this;
      let data = {
        text: arr, //带翻译数组
        from: localStorage.getItem("oldLanguageCode"), //源语言
        to: localStorage.getItem("curLanguageCode"), //目标语言
      };
      if (data.from == data.to) {
        return;
      }
      this.$http.translateByArr(data, callback, errCallBack);
    },

    languageTranslateByArrs(arr) {
      let that = this;
      let newpagetextArr = [];
      that.translateByArr(arr, (res) => {
        console.log("res", res);
        res.data.forEach((item, index) => {
          newpagetextArr.push(item.translation);
        });
        that.pageTextArr = newpagetextArr;
      });
    },
    /**
     * 跳转首页
     */
     toPersonCenter() {
        this.$router.push({
          path: "/",
        });
    }
  },
  model() {
    // this.detail = localStorage.getItem("detail");
    // console.log('this.detail',this.detail);
  },

  mounted() {
    let that = this;
    // 当前语言
    that.currLanguage = localStorage.getItem("curLanguageType");
    // 获取页面底部
    that.getBottomDetail();
    that.languageTranslateByArrs(that.pageTextArr);
  },
};
</script>

<style lang="scss" scoped>
.news-policy-modular {
  // background-color: white;
  .news-policy-content {
    margin: 0 auto;
    // width: 60%;
    width: 1200px;
    background-color: #FFFFFF;
    padding: 20px 0;

    min-height: calc(100vh - 125px);

    .el-breadcrumb {
      font-size: 16px;
    }

    .news-policy-detail {
      // margin-top: 20px;
      // height: 200px;
      padding-left: 20px;
      padding-right: 20px;
      p {
        margin-top: 10px !important;
      }
    }
  }

  // background-color: white;
}
@media screen and (max-width: 500px) {
  .news-policy-content {
    width: 85% !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/newsPolicy.vue